import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc3bf9e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "services" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wave" }, null, -1))
const _hoisted_3 = { class: "servicesWrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("WAAR BEN JE NAAR "),
  /*#__PURE__*/_createElementVNode("span", null, "OP ZOEK"),
  /*#__PURE__*/_createTextVNode("?")
], -1))
const _hoisted_5 = { class: "servicesList" }
const _hoisted_6 = { class: "servicesListWrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wave inverted" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ServiceItemComponent = _resolveComponent("ServiceItemComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service) => {
            return (_openBlock(), _createBlock(_component_ServiceItemComponent, {
              item: service,
              key: service.id
            }, null, 8, ["item"]))
          }), 128))
        ])
      ])
    ]),
    _hoisted_7
  ]))
}